module.exports = __webpack_public_path__ + "static/media/zheng2-1@3x.6c6fd36d.png";